import { render, staticRenderFns } from "./fireworks.vue?vue&type=template&id=20b1f74e&scoped=true"
import script from "./fireworks.vue?vue&type=script&lang=js"
export * from "./fireworks.vue?vue&type=script&lang=js"
import style0 from "./fireworks.vue?vue&type=style&index=0&id=20b1f74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1f74e",
  null
  
)

export default component.exports